// src/services/crmLeadStorage.ts
// ============================================
// Phase 2.2 内容发布 → CRM 留资线索闭环
//
// 内容发布成功后，把「该条内容开始引流」记为一笔 CRM 线索（source=发布平台），
// 与 GEO 获客同源：落盘 XEAOS/CRM/{source}/{date}/{slug}.md，供老板/销售在客户中心跟进归因。
//
// 用法：发布成功/手动发布提示后调用 recordCrmLeadFromContent({ platform, title, link })。
// 失败不阻断主流程（仅 console.warn）。
// ============================================

interface ContentLeadMeta {
  platform?: string; // 公众号 / 小红书 / 抖音 / 知乎 / B站 / 百家号
  title?: string;
  link?: string;
  note?: string;
}

const normalizeSource = (platform?: string): string => {
  const p = (platform || '').trim();
  if (!p) return '内容渠道';
  if (p.includes('微信') || p.includes('公众号')) return '公众号';
  if (p.includes('小红书')) return '小红书';
  if (p.includes('抖')) return '抖音';
  if (p.includes('知乎')) return '知乎';
  if (p.includes('B站')) return 'B站';
  if (p.includes('百家号')) return '百家号';
  if (p.includes('CSDN')) return 'CSDN';
  if (p.includes('头条')) return '头条号';
  return p.slice(0, 20);
};

/**
 * 记录一笔内容驱动留资线索。返回是否落盘成功。
 */
export async function recordCrmLeadFromContent(
  meta: ContentLeadMeta
): Promise<boolean> {
  const source = normalizeSource(meta.platform);
  const payload = {
    source,
    platform: meta.platform || source,
    name: `${source}-内容引流`,
    title: meta.title || '',
    link: meta.link || '',
    note:
      meta.note ||
      `内容发布引流：${source}${meta.title ? `《${meta.title}》` : ''}已发布，可带来询单/留资，待跟进确认意向。`,
  };
  try {
    const resp = await fetch('/api/crm/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!resp.ok && resp.status === 401) {
      // 未登录无法记录，属预期降级
      return false;
    }
    return resp.ok;
  } catch {
    return false;
  }
}